import { render, staticRenderFns } from "./splash-image-icon.vue?vue&type=template&id=40e36604&functional=true&"
import script from "./splash-image-icon.vue?vue&type=script&lang=js&"
export * from "./splash-image-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports